module.exports = __webpack_public_path__ + "static/media/user-placeholder.0c6692ea.svg";